/**
 * Created by Fatih on 11.11.2016.
 * Careless whisper
 */
import { pushBack } from './store/history';

const $verifyResultWrapper = document.getElementsByClassName('js-verify_email_result')[0];
const $successResponse = $verifyResultWrapper.querySelector('#mail-verify-success-text');
const $failResponse = $verifyResultWrapper.querySelector('#mail-verify-fail-text');
const $alreadyVerifiedResponse = $verifyResultWrapper.querySelector('#mail-verify-already-text');
const $resultOkBttn = $verifyResultWrapper.querySelector('.btn-ok');
const $verifyEmailResultCloseBttn = $verifyResultWrapper.querySelector('.icon-close');

function setActive(bool, param) {
	if (bool && param) {
		handleResponse(param)
		$verifyResultWrapper.classList.add('menu--is-open');
	} else {
		$verifyResultWrapper.classList.remove('menu--is-open');
	}
}

function handleResponse(response) {
	$successResponse.classList.add('u-hide');
	$alreadyVerifiedResponse.classList.add('u-hide');
	$failResponse.classList.add('u-hide');

	switch (response) {
		case 'success':
			$successResponse.classList.remove('u-hide');
			break;
		case 'already-verified':
			$alreadyVerifiedResponse.classList.remove('u-hide');
			break;
		case 'failed':
			$failResponse.classList.remove('u-hide');
			break;
		default:
			$failResponse.classList.remove('u-hide');
			break;
	}

	$resultOkBttn.classList.remove('u-hide');
}

$verifyEmailResultCloseBttn.addEventListener('click', (e) => {
	e.preventDefault();
	e.stopPropagation();
	pushBack();
});

export default {
	setActive
}



// WEBPACK FOOTER //
// ./mobile-core/src/email-verify-result.js